<style scoped lang="scss">
    .error-message {
        display: block;
    }
</style>
<template>
    <p class="help is-danger" v-if="errors && errors.length">
        <span class="error-message" v-for="error of errors">{{ error }}</span>
    </p>
</template>
<script>
export default {
    props : {
        errors : Array
    }
}
</script>
